<template>
    <div class="mb-4">

        <b-row class="align-items-end">
            <b-form-group class="col-lg-2 mb-0">
                <div><label>Type</label></div>
                <Select
                    v-model="filters.type"
                    placeholder="Select a type..."
                    action="selects/getCostTypes"
                    @input="applyFilters"
                />
            </b-form-group>
            <b-form-group class="col-lg-2 mb-0">
                <div><label>Status</label></div>
                <Select
                    v-model="filters.status"
                    placeholder="Select a status..."
                    action="selects/getCostStatuses"
                    @input="applyFilters"
                />
            </b-form-group>
            <b-form-group class="col-lg-2 mb-0">
                <div><label>Reconciled</label></div>
                <Select
                    v-model="filters.reconciled"
                    placeholder="Select..."
                    :options="reconciledOptions"
                    @input="applyFilters"
                />
            </b-form-group>
            <b-form-group class="col-lg-3 mb-0">
                <div><label>Search</label></div>
                <b-form-input
                    v-model="filters.search"
                    placeholder="Enter a query..."
                    @input="debounceSearch"
                />
            </b-form-group>
            <div class="col-lg-1 d-flex align-items-end">
                <b-button
                    size="lg"
                    variant="warning"
                    block
                    :disabled="isTableLoading"
                    @click="resetFilters"
                >
                    <i
                        class="fa fa-fw fa-refresh"
                        :class="{ 'fa-spin': isTableLoading }"
                    />
                </b-button>
            </div>
            <div class="col-lg-2 d-flex align-items-end">
                <b-button
                    v-b-toggle.more-filters
                    size="lg"
                    variant="primary"
                    block
                >
                    More Filters
                </b-button>
            </div>
        </b-row>

        <b-collapse
            id="more-filters"
            class="mb-4"
        >
            <b-row class="mt-3">
                <b-form-group class="col-lg-2 mb-0">
                    <div><label>Taxable</label></div>
                    <Select
                        v-model="filters.vatable"
                        placeholder="Select..."
                        :options="vatableOptions"
                        @input="applyFilters"
                    />
                </b-form-group>
                <b-form-group class="col-lg-2 mb-0">
                    <div><label>Billable</label></div>
                    <Select
                        v-model="filters.billable"
                        placeholder="Select..."
                        :options="billableOptions"
                        @input="applyFilters"
                    />
                </b-form-group>
                <b-form-group class="col-lg-2 mb-0">
                    <div><label>User</label></div>
                    <UserSelect
                        v-model="filters.user"
                        @input="applyFilters"
                    />
                </b-form-group>
                <b-form-group class="col-lg-2 mb-0">
                    <div><label>{{ $t('cost.transaction_type') }}</label></div>
                    <TransactionTypeSelect
                        v-model="filters.transaction_type"
                        @input="applyFilters"
                    />
                </b-form-group>
                <b-form-group
                    v-if="!$store.getters['costable/settings'].hide_cost_statuses && $store.getters['costable/settings'].show_secondary_cost_status"
                    class="col-lg-2 mb-0"
                >
                    <div><label>{{ $t('cost.secondary_status') }}</label></div>
                    <Select
                        v-model="filters.secondary_status"
                        placeholder="Select a secondary status..."
                        action="selects/getSecondaryCostStatuses"
                        @input="applyFilters"
                    />
                </b-form-group>
            </b-row>
        </b-collapse>

    </div>
</template>

<script>
import debounce from 'debounce';
import UserSelect from '@/components/UserSelect';
import TransactionTypeSelect from '@/components/TransactionTypeSelect';

export default {
    components: { TransactionTypeSelect, UserSelect },
    data() {
        return {
            reconciledOptions: [
                {
                    id: 0,
                    label: 'Unreconciled',
                }, {
                    id: 1,
                    label: 'Reconciled',
                },
            ],
            vatableOptions: [
                {
                    id: 0,
                    label: 'Not Taxable',
                },
                {
                    id: 1,
                    label: 'Taxable',
                },
            ],
            billableOptions: [
                {
                    id: 0,
                    label: 'Not Billable',
                },
                {
                    id: 1,
                    label: 'Billable',
                },
            ],
            filters: {
                type: null,
                status: null,
                reconciled: null,
                search: '',
                vatable: null,
                billable: null,
                user: null,
                transaction_type: null,
                secondary_status: null,
            },
        };
    },

    computed: {
        isTableLoading() {
            return this.$store.getters['costable/isCostableTableLoading'];
        },
    },

    methods: {
        debounceSearch: debounce(function debouncedSearch() {
            this.applyFilters();
        }, 500),
        async applyFilters() {
            await this.$store.dispatch('costable/updateFilters', this.filters);
            await this.$store.dispatch('costable/applyFilters', { shouldNotify: true });
        },
        async resetFilters() {
            this.filters = {
                type: null,
                status: null,
                reconciled: null,
                search: '',
            };
            await this.$store.dispatch('costable/resetFilters');
        },
    },

};
</script>
